import { render, staticRenderFns } from "./jianbao.vue?vue&type=template&id=13adc3a2&"
import script from "./jianbao.vue?vue&type=script&lang=js&"
export * from "./jianbao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports